import React from 'react';
import { resources } from '../../resources/strings';
import './styles.scss';

interface IProps {
    isCentred?: boolean;
    isLarge?: boolean;
}

class LandingHeader extends React.Component<IProps> {
    render() {
        const headerStrings = resources.header;

        return (
            <div className={`landing-header sj-header ${ this.props.isCentred ? 'centred' : ''}`}>
                <div className={`logo${this.props.isLarge ? ' logo--large' : ''}`} />
                <div className='header-title'>
                    {headerStrings.title}
                </div>
            </div>
        );
    };
}

export default LandingHeader;
